import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

const STATUS_OPTIONS = [
  { id: 1, name: "برحال" },
  { id: 0, name: "اسبق" },
];

class TeacherForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      gender: [],
      faculty: [],
      department: [],
      entry_year: [],
      user_status: STATUS_OPTIONS,
    },
    data: {
      teacher_name: "",
      teacher_name_en: "",
      teacher_lastname: "",
      teacher_lastname_en: "",
      teacher_phone: "",
      teacher_email: "",
      teacher_dob: "",
      gender: "",
      faculty: "",
      department: "",
      second_job: 0,
      is_general: 0,
      user_status: 1,
      teacher_photo: "",
    },
    canSetStatus: false,
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const {
      popUp: { edit },
    } = this.context;

    let canSetStatus = false;
    try {
      const { data: caps } = await db.getAll("mis-parity/capabilities");
      canSetStatus = caps?.summary?.superuser === true;
    } catch (_) {
      canSetStatus = false;
    }

    if (edit) {
      data.teacher_name = edit.first_name;
      data.teacher_name_en = edit.first_name_en;
      data.teacher_lastname = edit.last_name;
      data.teacher_lastname_en = edit.last_name_en;
      data.teacher_phone = edit.teacher_phone;
      data.teacher_photo = edit.teacher_photo;
      data.teacher_email = edit.teacher_email;
      data.teacher_dob = edit.teacher_dob;
      data.gender = edit.gender_id;
      data.faculty = edit.faculty_id;
      data.department = edit.department_id;
      data.second_job = edit.second_job;
      data.is_general = edit.is_general === 1 || edit.is_general === "1" ? 1 : 0;
      data.user_status = Number(edit.user_status) === 0 ? 0 : 1;
    }

    await db
      .getAll(`dropdowns/genders`)
      .then(({ data: { data } }) => (drp["gender"] = data));

    await db
      .getAll(`dropdowns/faculties`)
      .then(({ data: { data } }) => (drp["faculty"] = data));

    if (data.faculty) {
      const faculty_id = data.faculty;
      await db
        .getAll(`dropdowns/departments`)
        .then(
          ({ data: { data } }) =>
            (drp["department"] = data.filter(
              (department) => department.faculty === faculty_id
            ))
        );
    }

    this.setState({ drp, data, canSetStatus });
  };

  reloadDepartments = async (e) => {
    const { data, drp } = this.state;

    data.faculty = e.data.id;
    const faculty_id = data.faculty;

    data.department = null;
    drp.department = [];

    await db
      .getAll(`dropdowns/departments`)
      .then(
        ({ data: { data } }) =>
          (drp["department"] = data.filter(
            (department) => department.faculty === faculty_id
          ))
      );

    this.setState({ data, drp });
  };

  schema = {
    teacher_name: Joi.string().max(32),
    teacher_name_en: Joi.string().max(32),
    teacher_lastname: Joi.string().max(32),
    teacher_lastname_en: Joi.string().max(32),
    teacher_phone: Joi.string().max(14),
    teacher_photo: Joi.string().max(256).allow(null).allow(""),
    teacher_email: Joi.string().max(64),
    teacher_dob: Joi.string(),
    gender: Joi.number(),
    faculty: Joi.number(),
    department: Joi.number().allow(null, ""),
    second_job: Joi.number(),
    is_general: Joi.number().allow(0, 1),
    user_status: Joi.number().allow(0, 1),
  };

  doSubmit = async (e) => {
    const { togglePopUp, popUp } = this.context;
    const { canSetStatus } = this.state;

    let __controls = this.cleanObject({
      ...this.state.data,
    });
    if (this.state.data.department === "" || this.state.data.department == null) {
      __controls.department = null;
    }
    __controls.is_general =
      this.state.data.is_general === 1 || this.state.data.is_general === "1" ? 1 : 0;

    // Owner-only field; never send for add or non-owner edits.
    if (!(canSetStatus && popUp?.edit?.teacher_id)) {
      delete __controls.user_status;
    } else {
      __controls.user_status = Number(this.state.data.user_status) === 0 ? 0 : 1;
    }

    try {
      await db
        .form("teachers", e.target, __controls, popUp?.edit?.teacher_id)
        .then(() => {
          togglePopUp({ form: "toast" });
        })
        .catch((e) => {
          const apiMsg =
            e?.response?.data?.error?.message ||
            e?.response?.data?.message ||
            e?.message ||
            String(e);
          togglePopUp({
            form: "toast",
            message: apiMsg,
            type: "warning",
          });
        });
      if (popUp.callback) popUp.callback();
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { data, drp, canSetStatus } = this.state;
    const { popUp } = this.context;
    const showStatus = canSetStatus && !!popUp?.edit;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditTeacher : lbl.AddTeacher}</p>
          </div>
          <div className="form-inputs">
            {this.renderImg("teacher_photo", data.teacher_photo)}
            <div className="multi-input">
              {this.renderInput("teacher_name", "اسم", "text")}
              {this.renderInput("teacher_name_en", "Name", "text")}
            </div>
            <div className="multi-input">
              {this.renderInput("teacher_lastname", "تخلص", "text")}
              {this.renderInput("teacher_lastname_en", "Last name", "text")}
            </div>
            <div className="multi-input">
              {this.renderSelect(
                "faculty",
                "پوهنحی",
                drp["faculty"],
                false,
                this.reloadDepartments
              )}
              {this.renderSelect(
                "department",
                "دپارتمنت",
                [{ id: null, name: "دپارتمنت عمومی" }].concat(
                  drp["department"] || []
                )
              )}
            </div>
            <div className="multi-input">
              {this.renderSelect("gender", "جنسیت", drp["gender"])}
              {this.renderInput("teacher_dob", "تاریخ تولد", "date")}
            </div>
            <div className="multi-input">
              {this.renderInput("teacher_phone", "شماره تماس", "text")}
              {this.renderInput("teacher_email", "ایمیل", "text")}
            </div>
            {showStatus ? (
              <div className="multi-input">
                {this.renderSelect("user_status", "وضعیت", drp["user_status"])}
              </div>
            ) : null}
            <div className="multi-input checkbox teacher-general-opts">
              {this.renderCheckBox("second_job", "", "وظیفه دوم")}
              {this.renderCheckBox(
                "is_general",
                "",
                "عمومی (همه پوهنحی‌ها)"
              )}
            </div>
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default TeacherForm;
